import React, { ChangeEvent, Component, MouseEvent } from "react";

import {
  GetLanguageValue,
  ITranslateProps,
} from "@/components/Application/Translate";

import { Language } from "@/model/Language/Language";
import { TranslationConsumer } from "@/model/Translation/TranslationContext";

interface IButtonTranslateProps extends ITranslateProps {
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  value?: string;
}

export class Button extends Component<IButtonTranslateProps, any> {
  renderTranslation(ctx: Language | null) {
    const { value, missingTranslationKey } = GetLanguageValue(
      ctx,
      this.props.String,
      this.props.value ? this.props.value : this.props.children,
    );
    return this.props.value ? (
      <button
        onClick={this.props.onClick}
        className={this.props.className}
        type="button"
        title={missingTranslationKey}
        value={value?.toString()}
      ></button>
    ) : (
      <button
        onClick={this.props.onClick}
        className={this.props.className}
        type="button"
        title={missingTranslationKey}
      >
        {value}
      </button>
    );
  }
  render() {
    return (
      <TranslationConsumer>
        {(ctx: Language | null) => this.renderTranslation(ctx)}
      </TranslationConsumer>
    );
  }
}

interface IValueTranslateProps {
  value: string | number;
}
interface IInputTranslateProps extends IValueTranslateProps {
  id?: string;
  className?: string;
  name: string;
  placeholder: { key: string; value: string };
  type: "text" | "hidden" | "search";
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export class Input extends Component<IInputTranslateProps> {
  renderTranslation(ctx: Language | null) {
    const { value: translated, missingTranslationKey } = GetLanguageValue(
      ctx,
      this.props.placeholder.key,
      this.props.placeholder.value,
    );
    return (
      <input
        id={this.props.id}
        className={this.props.className}
        type={this.props.type}
        onChange={this.props.onChange}
        name={this.props.name}
        value={this.props.value}
        placeholder={translated as string}
        title={missingTranslationKey}
      ></input>
    );
  }

  render() {
    return (
      <TranslationConsumer>
        {(ctx: Language | null) => this.renderTranslation(ctx)}
      </TranslationConsumer>
    );
  }
}

interface IOptionsTranslateProps extends ITranslateProps, IValueTranslateProps {
  selected?: boolean;
  disabled?: boolean;
}
export class Option extends Component<IOptionsTranslateProps> {
  renderTranslation(ctx: Language | null) {
    const { value: translated, missingTranslationKey } = GetLanguageValue(
      ctx,
      this.props.String,
      this.props.children,
    );
    return (
      <option
        selected={this.props.selected}
        className={this.props.className}
        value={this.props.value}
        title={missingTranslationKey}
        disabled={this.props.disabled}
      >
        {translated}
      </option>
    );
  }

  render() {
    return (
      <TranslationConsumer>
        {(ctx: Language | null) => this.renderTranslation(ctx)}
      </TranslationConsumer>
    );
  }
}

export function getButtonDisabledStyling(
  disabled: boolean,
): string | undefined {
  if (disabled) {
    return "button-icon button-text button--disabled";
  }

  return "button-icon button-text button--blue";
}
